import {
  Box,
  CardContent,
  CardHeader,
  IconButton,
  Link,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useSearchParams } from "react-router-dom";

import { MediaViewer } from "@/components/MediaViewer";
import { EditVideoDialog } from "../../components/EditVideoDialog";
import {
  RemoveVideoDialog,
  RemoveVideoDialogProps,
} from "../../components/RemoveVideoDialog";
import { Video } from "@/models";

export type VideoDetailProps = {
  data: Video;
};

const QUERY_KEY = "video";

export function VideoDetail({ data }: VideoDetailProps) {
  const { id, name, description, thumbnailUrl, youtubeUrl } = data;

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const dialog = searchParams.get("dialog");

  const mediaList = thumbnailUrl ? [{ url: thumbnailUrl }] : [];

  function onCloseDialog() {
    searchParams.delete("dialog");
    setSearchParams(searchParams, { replace: true });
  }

  function openEditDialog() {
    searchParams.set("dialog", "video-edit");
    setSearchParams(searchParams);
  }

  function openRemoveDialog() {
    searchParams.set("dialog", "video-remove");
    setSearchParams(searchParams);
  }

  const editDialog = {
    open: dialog === "video-edit",
    onClose() {
      searchParams.delete("dialog");
      setSearchParams(searchParams);
    },
    id: id.toString(),
    data,
    fetchKey: QUERY_KEY,
  };

  const removeDialog: RemoveVideoDialogProps = {
    open: dialog === "video-remove",
    onClose(reason) {
      onCloseDialog();
      if (reason === "success") {
        navigate("..");
      }
    },
    id: id.toString(),
    fetchKeys: [QUERY_KEY],
  };

  return (
    <Stack>
      <CardHeader
        title={name}
        action={
          <Stack direction="row">
            <Tooltip title="แก้ไข">
              <IconButton onClick={openEditDialog}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="ลบ">
              <IconButton onClick={openRemoveDialog}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        }
      />
      <CardContent sx={{ py: 0 }}>
        <MediaViewer mediaList={mediaList} imageWidth={300} imageHeight={200} />
      </CardContent>
      <CardContent>
        <Box
          display="grid"
          gridTemplateColumns="150px 1fr"
          gap={3}
          alignItems="baseline"
        >
          <Typography variant="body1" color="text.disabled" fontWeight={500}>
            ลิงค์ Youtube
          </Typography>
          <Typography variant="body2">
            <Link href={youtubeUrl} target="_blank" color="inherit">
              {youtubeUrl}
            </Link>
          </Typography>
          <Typography variant="body1" color="text.disabled" fontWeight={500}>
            รายละเอียด
          </Typography>
          <Typography variant="body2">{description}</Typography>
        </Box>
      </CardContent>
      <EditVideoDialog {...editDialog} />
      <RemoveVideoDialog {...removeDialog} />
    </Stack>
  );
}
